export default [
  {
    path: '/login',
    component: resolve => require(['@/views/Login'], resolve)
  }
]
